import { render, staticRenderFns } from "./indexdef.vue?vue&type=template&id=7270d883"
import script from "./indexdef.vue?vue&type=script&lang=js"
export * from "./indexdef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports